import './StatusMessage.css';

interface Props {
  type: 'success' | 'error';
  message: string;
}

const StatusMessage = ({ type, message }: Props) => {
  return <div className={`status-message ${type}`}>{message}</div>;
};

export default StatusMessage;
